import React, { Component, Fragment } from 'react'
import { Translate } from '../../contexts/Language';
import { Card, BreadCrumb, Modal, JsonTable, Confirm } from '../../components';
import "react-datepicker/dist/react-datepicker.css";
import DataTable from 'react-data-table-component'
import { DataTableColumns } from '../../config/DataTableColumns';
import { Service } from '../../services';
import { Config } from '../../config';
import DataTableExtensions from 'react-data-table-component-extensions';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import { isArray } from 'util';



let beginDate = localStorage.getItem("beginDate"),
    endDate = localStorage.getItem("endDate");

export class InternalTransfer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            formData: {
                beginDate: (beginDate ? new Date(beginDate) : new Date()),
                endDate: (endDate ? new Date(endDate) : new Date()),
                status: -5,
                comment: ""
            },
            dataTable: {
                columns: DataTableColumns.internalTransfer,
                rows: []
            },
            modal: false,
            detail: {},
            readOnly: true,
            validation: {
                error: false,
                message: ""
            }
        }

        this.onDetail = this.onDetail.bind(this);
        this.onCloseModal = this.onCloseModal.bind(this);
        this.onEditSave = this.onEditSave.bind(this);
        this.onConfirm = this.onConfirm.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onDateChange = this.onDateChange.bind(this);

    }
    componentDidMount() {
        this.onFilter();
    }
    onFilter() {
        Config.utilities.loadingFetch();

        const formData = Object.assign({}, this.state.formData);
        let beginDate = new Date(formData.beginDate);
        formData.beginDate = new Date(beginDate.setDate(beginDate.getDate() + 1));

        Service.InternalTransfer.History(formData).then(response => {

            if (response) {

                let dataTable = this.state.dataTable;

                dataTable.rows = response;

                this.setState({
                    dataTable: dataTable
                });

            }

            Config.utilities.loadingFetch();
        });
    }
    onDateChange(date) {

        let tempData = this.state.formData;

        if (date !== null && isArray(date)) {
            tempData["beginDate"] = date[0];
            tempData["endDate"] = date[1];
        }
        else {
            tempData["beginDate"] = "";
            tempData["endDate"] = "";
        }
        this.setState({
            formData: tempData
        });
        localStorage.setItem("beginDate", tempData["beginDate"]);
        localStorage.setItem("endDate", tempData["endDate"]);
    }
    onChange(value, stateKey) {

        let tempData = this.state.formData;

        tempData[stateKey] = value

        this.setState({
            formData: tempData
        });

        localStorage.setItem(stateKey, value);
    }
    onCloseModal() {
        this.setState({
            modal: false,
            readOnly: true
        })
    }
    onConfirm(transactionId) {
        Confirm({
            title: Translate("Are you sure?"),
            type: { warning: true },
            description: Translate("This deposit will be confirmed"),
            onConfirm: () => {
                Config.utilities.loadingFetch();
                Service.InternalTransfer.Confirm({ 'TransactionId': transactionId, 'Type': "internal" }).then(response => {

                    if (response) {
                        this.setState({
                            readOnly: true,
                            modal: false,
                            validation: response
                        })
                        this.onFilter();
                    }

                    Config.utilities.loadingFetch();
                });
            },
            onCancel: () => {

            }
        });
    }
    onDetail(transactionId) {
        Config.utilities.loadingFetch();

        Service.InternalTransfer.Detail({ "TransactionId": transactionId }).then(response => {

            if (response) {

                if (response.requestHeader !== null)
                    response.requestHeader = JSON.parse(response.requestHeader);

                if (response.comment !== null) {
                    let comment = JSON.parse(response.comment);
                    response.comment = comment.Comment;
                }

                let formData = this.state.formData;
                formData.comment = response.comment;

                this.setState({
                    detail: response,
                    formData: formData,
                    modal: true
                });

            }

            Config.utilities.loadingFetch();
        });
    }

    onCancel(transactionId) {
        Confirm({
            title: Translate("Are you sure?"),
            type: { warning: true },
            description: Translate("This withdrawal will be canceled"),
            onConfirm: () => {
                Config.utilities.loadingFetch();
                Service.InternalTransfer.Cancel({ 'TransactionId': transactionId, 'Type': "internal" }).then(response => {

                    if (response) {
                        this.setState({
                            readOnly: true,
                            modal: false,
                            validation: response
                        })
                        this.onFilter();
                    }

                    Config.utilities.loadingFetch();
                });
            },
            onCancel: () => {

            }
        });
    }
    onEditSave() {
        if (this.state.readOnly) {
            this.setState({
                readOnly: false
            })
        }
        else {

            Config.utilities.loadingFetch();

            Service.InternalTransfer.SaveComment({ 'TransactionId': this.state.detail.transactionId, 'Comment': this.state.formData.comment, 'Type': "internal" }).then(response => {

                if (response) {
                    this.setState({
                        readOnly: true,
                        modal: false
                    })
                }

                Config.utilities.loadingFetch();
            });
        }
    }

    render() {
        return (
            <Fragment>
                <BreadCrumb Title={Translate("Internal Transfer")} Name={Translate("Internal Transfer")} />
                <Modal Title={Translate("Internal Transfer Detail")} Show={this.state.modal} onClose={this.onCloseModal}>
                    <div className="row mt-1 mb-1">
                        <p className="text-muted mb-2 ml-1 col-md-12 font-12">{Translate("Transfer Information")} [#{this.state.detail.id}]</p>
                        <div className="col-md-6">
                            <dl className="row mb-0 ml-1 dl-striped">
                                <dt className="col-sm-6">{Translate('Status')}</dt>
                                <dd className="col-sm-6"><span className={"badge pb-1 font-12 payment-status " + this.state.detail.statusClass}>{Translate(this.state.detail.statusTitle)}</span></dd>
                                <dt className="col-sm-6">{Translate('Boss ID')}</dt>
                                <dd className="col-sm-6">{this.state.detail.bossId}</dd>
                                <dt className="col-sm-6">{Translate('From Account')}</dt>
                                <dd className="col-sm-6">{this.state.detail.fromAccount}</dd>
                                <dt className="col-sm-6">{Translate('From Account Amount')}</dt>
                                <dd className="col-sm-6">{this.state.detail.fromAmount} &nbsp; {this.state.detail.fromAccountCurrency}</dd>


                                <dt className="col-sm-6">{Translate('To Account')}</dt>
                                <dd className="col-sm-6">{this.state.detail.toAccount}</dd>
                                <dt className="col-sm-6">{Translate('To Amount')}</dt>
                                <dd className="col-sm-6">{this.state.detail.toAmount} &nbsp; {this.state.detail.toAccountCurrency}</dd>
                                <dt className="col-sm-6">{Translate('Exchange Rate')}</dt>
                                <dd className="col-sm-6">{this.state.detail.exchangeRate}</dd>
                            </dl>
                        </div>
                        <div className="col-md-6">
                            <dl className="row mb-0 ml-1 mr-1 dl-striped">
                                <dt className="col-sm-6">{Translate('Date')}</dt>
                                <dd className="col-sm-6">{this.state.detail.insertDate}</dd>
                                <dt className="col-sm-6">{Translate('MetaTicket')}</dt>
                                <dd className="col-sm-6">{this.state.detail.metaTicket}</dd>
                                <dt className="col-sm-3">{Translate('Comment')}</dt>
                                <dd className="col-sm-9">
                                    <div className="input-group input-group-sm">
                                        <textarea className="form-control input-sm" type="text" id="comment" name="comment" onChange={(e) => this.onChange(e.target.value, "comment")} onFocus={e => e.target.select()} readOnly={this.state.readOnly}>
                                            {this.state.formData.comment}
                                        </textarea>
                                        <div className="input-group-append hide">
                                            <button type="button" className="input-group-text pt-0 pb-0 bg-info text-white btn-sm" id="availableMargin" onClick={(e) => this.onEditSave()}>
                                                {this.state.readOnly ? Translate("Edit") : Translate("Save")}
                                            </button>
                                        </div>
                                    </div>
                                </dd>
                            </dl>
                        </div>

                        {this.state.detail.requestHeader ?
                            <Fragment>
                                <p className="text-muted mb-2 mt-3 ml-1 col-md-12 font-12">{Translate("Request Header")} &nbsp;</p>
                                <div className="col-md-12">
                                    <JsonTable Data={[this.state.detail.requestHeader]} />
                                </div>
                            </Fragment> : ""}
                    </div>
                </Modal>
                <Card Title="Customer Internal Transfer" Description="History of internal transfer">
                    <div className="row mb-3">
                        <div className="col-md-2">
                            <div className="form-group mb-0">
                                <label>Status</label>
                                <select className="form-control" name="status" id="status" onChange={(e) => this.onChange(e.target.value, "status")}>
                                    <option value="-5">All</option>
                                    <option value="-4">Failed</option>
                                    <option value="-3">Error</option>
                                    <option value="-2">Temp</option>
                                    <option value="-1">Cancel</option>
                                    <option value="0">Pending</option>
                                    <option value="1">Confirm</option>
                                    <option value="2">Manual</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-group mb-0">
                                <label>Date Range</label>
                                <div>
                                    <DateRangePicker className="date-range-picker form-control"
                                        onChange={this.onDateChange}
                                        value={[this.state.formData.beginDate, this.state.formData.endDate]}
                                        format={"dd.MM.yyyy"}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-2">
                            <div className="form-group mb-0">
                                <label>&nbsp;</label>
                                <button type="button" className="btn btn-dark bg-dark btn-block" onClick={e => this.onFilter(e)}>Filter History</button>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className={"col-md-12 " + (this.state.validation.error ? "" : "d-none")}>
                            <div className={"alert alert-danger alert-dismissible fade mb-0 show"} role="alert">
                                <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                                <strong>{Translate("Error !")}</strong> {this.state.validation.message}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            {this.state.dataTable.rows.length === 0 ? (
                                <div className="alert alert-light" role="alert">
                                    <em><strong>No record!</strong> {Translate('No records found for the filter.')} </em>
                                </div>) :
                                (<DataTableExtensions columns={this.state.dataTable.columns(this.onConfirm, this.onDetail, this.onCancel)} data={this.state.dataTable.rows} exportHeaders={true}>
                                    <DataTable
                                        noHeader={true}
                                        defaultSortField="insertDate"
                                        defaultSortAsc={false}
                                        pagination
                                        highlightOnHover />
                                </DataTableExtensions>)}
                        </div>
                    </div>
                </Card>
            </Fragment>
        )
    }
}